import { FC, useEffect } from "react";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import * as Styled from "./card.styles";

interface CardMissionProps {
  cardInfo: string;
  idx: number;
  selecteditem?: number;
}

export const CardMission: FC<CardMissionProps> = ({ cardInfo, idx, selecteditem }) => {
  const { t } = useTranslation("global");
  const control = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      control.start("visible");
    }
  }, [control, inView]);

  const boxVariant = {
    visible: { opacity: 1, scale: 1, transition: { duration: 1 } },
    hidden: { opacity: 0, scale: 0 },
  };

  return (
    <Styled.CardMission>
      <Styled.CardMissionImage selecteditem={selecteditem}>
        <motion.div variants={boxVariant} initial="hidden" animate={control} className="box" ref={ref}>
          <Styled.CustomeImg selecteditem={selecteditem}>
            <Image src={t(`${cardInfo}.img`) as string} alt={t(`${cardInfo}.title`) as string} fill />
          </Styled.CustomeImg>
        </motion.div>
      </Styled.CardMissionImage>
      <Styled.CardMissionTitle className="headline-medium weight-medium" selecteditem={selecteditem} style={{ textAlign: "center" }}>
        {/* get  description */}
        {t(`${cardInfo}.title`)}
      </Styled.CardMissionTitle>
      <Styled.CardMissionDescription className="body-medium" selecteditem={selecteditem}>
        {t(`${cardInfo}.description`)}
      </Styled.CardMissionDescription>
    </Styled.CardMission>
  );
};
